import React from "react";
import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import { CheckCircle, ArrowRight, Clock } from "lucide-react";
import { mockData } from "../mock";

export const Process = () => {
  return (
    <section
      id="process"
      className="py-20 bg-gradient-to-br from-gray-50 to-blue-50"
    >
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-4xl font-bold text-gray-900">
            A Structured 16 Week Path to a Developer Career
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A structured learning journey designed to transform beginners into
            industry-ready developers through practical training, mentorship,
            and real-world exposure
          </p>
        </div>

        {/* Process Steps */}
        <div className="max-w-4xl mx-auto space-y-8">
          {mockData.processSteps.map((step, index) => (
            <div key={step.step} className="relative">
              {/* Connection Line */}
              {index < mockData.processSteps.length - 1 && (
                <div className="absolute left-6 top-16 w-0.5 h-16 bg-blue-200 z-0 hidden md:block" />
              )}

              <Card className="relative bg-white hover:shadow-lg transition-all duration-300 overflow-hidden">
                <CardContent className="p-8">
                  <div className="flex flex-col md:flex-row md:items-center gap-6">
                    {/* Step Number */}
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-lg relative z-10">
                        {step.step}
                      </div>
                    </div>

                    {/* Step Content */}
                    <div className="flex-1 space-y-3">
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                        <h3 className="text-2xl font-bold text-gray-900">
                          {step.title}
                        </h3>
                        <Badge className="bg-blue-50 text-blue-700 w-fit">
                          <Clock size={14} className="mr-1" />
                          {step.duration}
                        </Badge>
                      </div>

                      <p className="text-gray-700 text-lg leading-relaxed">
                        {step.description}
                      </p>

                      {/* Step Details */}
                      {step.step === 1 && (
                        <div className="grid sm:grid-cols-2 gap-2 text-sm text-gray-600 mt-4">
                          <div className="flex items-center gap-2">
                            <CheckCircle size={16} className="text-green-500" />
                            No prior programming experience required
                          </div>
                        </div>
                      )}

                      {step.step === 2 && (
                        <div className="grid sm:grid-cols-2 gap-2 text-sm text-gray-600 mt-4">
                          <div className="flex items-center gap-2">
                            <CheckCircle size={16} className="text-green-500" />
                            Fundamental aptitude and learning readiness
                            assessment
                          </div>
                          <div className="flex items-center gap-2">
                            <CheckCircle size={16} className="text-green-500" />
                            Mentor allocation and cohort assignment
                          </div>
                        </div>
                      )}

                      {step.step === 3 && (
                        <div className="grid sm:grid-cols-2 gap-2 text-sm text-gray-600 mt-4">
                          <div className="flex items-center gap-2">
                            <CheckCircle size={16} className="text-green-500" />
                            Development environment configuration and setup
                          </div>
                          <div className="flex items-center gap-2">
                            <CheckCircle size={16} className="text-green-500" />
                            Collaboration workflows and team tools
                          </div>
                        </div>
                      )}

                      {step.step === 4 && (
                        <div className="grid sm:grid-cols-2 gap-2 text-sm text-gray-600 mt-4">
                          <div className="flex items-center gap-2">
                            <CheckCircle size={16} className="text-green-500" />
                            Development of 2-3 industry-aligned production
                            projects
                          </div>
                          <div className="flex items-center gap-2">
                            <CheckCircle size={16} className="text-green-500" />
                            Weekly mentor reviews and technical feedback
                          </div>
                        </div>
                      )}

                      {step.step === 5 && (
                        <div className="grid sm:grid-cols-2 gap-2 text-sm text-gray-600 mt-4">
                          <div className="flex items-center gap-2">
                            <CheckCircle size={16} className="text-green-500" />
                            Structured portfolio presentation sessions
                          </div>
                          <div className="flex items-center gap-2">
                            <CheckCircle size={16} className="text-green-500" />
                            Direct introductions to hiring and partner
                            organizations
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">
            Ready to take the next step in your career?
          </p>
          <button
            type="button"
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors inline-flex items-center gap-2"
            onClick={() =>
              window.open(
                "https://api.whatsapp.com/send?phone=919895223307",
                "_blank"
              )
            }
          >
            Apply Now to Join the Next Cohort
            <ArrowRight size={20} />
          </button>
        </div>
      </div>
    </section>
  );
};
